
import { Vue, Component, Prop } from "vue-property-decorator";
import AdmButton from "@afe/admirals-dev/src/components/AdmButton";
@Component({
  components: { AdmButton }
})
export default class extends Vue {
  @Prop(String) readonly title!: string;
  @Prop(String) readonly p1!: string;
  @Prop(String) readonly p2!: string;
  @Prop(String) readonly submit!: string;

  isShow = true;

  onClose() {
    this.isShow = false;
    document.body.style.overflow = "initial";
  }

  mounted() {
    document.body.style.overflow = "hidden";
  }
}
